import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TooltipConfig, TooltipModule } from 'ngx-bootstrap/tooltip';

import { WizardComponent } from './wizard.component';
import { WizardReviewComponent } from './wizard-review.component';
import { WizardStepComponent } from './wizard-step.component';
import { WizardSubstepComponent } from './wizard-substep.component';

/**
 * A module containing objects associated with the wizard component
 */

export class WizardModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    TooltipModule.forRoot()
  ],
  declarations: [WizardComponent, WizardReviewComponent, WizardStepComponent, WizardSubstepComponent],
  exports: [WizardComponent, WizardReviewComponent, WizardStepComponent, WizardSubstepComponent],
  providers: [TooltipConfig]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
